var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlandetox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 271.12,
    height: 140.857,
    viewBox: "0 0 271.12 140.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#6a841e;}.c{filter:url(#q);}.d{filter:url(#o);}.e{filter:url(#m);}.f{filter:url(#k);}.g{filter:url(#i);}.h{filter:url(#g);}.i{filter:url(#e);}.j{filter:url(#c);}.k{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.188,
    y: 0,
    width: 49.175,
    height: 61.065,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 38.553,
    y: 0,
    width: 45.813,
    height: 61.065,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 66.655,
    y: 0,
    width: 58.339,
    height: 61.065,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 113.199,
    y: 0,
    width: 55.323,
    height: 61.065,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 0,
    y: 68.569,
    width: 64.872,
    height: 71.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 56.267,
    y: 68.605,
    width: 57.744,
    height: 71.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 101.951,
    y: 68.605,
    width: 60.156,
    height: 71.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 147.093,
    y: 67.813,
    width: 73.08,
    height: 73.044,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 202.642,
    y: 68.569,
    width: 68.477,
    height: 71.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-515.803 -752.842)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, 517.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M526.991,760.205q0-1.362,1.3-1.363h16.472a12.655,12.655,0,0,1,5.394,1.145,13.562,13.562,0,0,1,4.248,3.06,14.057,14.057,0,0,1,3.756,9.57,13.684,13.684,0,0,1-.973,5.09,13.887,13.887,0,0,1-2.729,4.349,13.408,13.408,0,0,1-4.2,3.045,12.409,12.409,0,0,1-5.343,1.146h-9.553V800.66q0,1.248-1.3,1.247h-5.809a1.112,1.112,0,0,1-1.271-1.247ZM549.7,772.573a6.19,6.19,0,0,0-.465-2.34,6.725,6.725,0,0,0-1.279-2.034,6.428,6.428,0,0,0-1.947-1.438,5.554,5.554,0,0,0-2.47-.553h-8.165v12.731h8.165a5.751,5.751,0,0,0,2.441-.523,6.25,6.25,0,0,0,1.962-1.409,6.578,6.578,0,0,0,1.293-2.036A6.323,6.323,0,0,0,549.7,772.573Z",
    transform: "translate(-517.8 -752.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, 517.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M565.356,760.118a1.243,1.243,0,0,1,1.33-1.276h5.752a1.362,1.362,0,0,1,.91.334,1.17,1.17,0,0,1,.389.942v33.843h18.154a1.26,1.26,0,0,1,.9.362,1.292,1.292,0,0,1,.377.972V800.6a1.331,1.331,0,0,1-.35.913,1.177,1.177,0,0,1-.928.392H566.628a1.126,1.126,0,0,1-1.272-1.276Z",
    transform: "translate(-517.8 -752.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 517.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M593.487,800.834a9.367,9.367,0,0,1,.333-1.073c.126-.329.236-.628.334-.9l15.631-38.918a1.73,1.73,0,0,1,.478-.711,1.431,1.431,0,0,1,1.059-.391h4.669a1.267,1.267,0,0,1,1,.348,3.789,3.789,0,0,1,.45.609l.957,2.262L633.71,800.37a1.758,1.758,0,0,0,.044.3,1.977,1.977,0,0,1,.043.362q0,.87-1.276.87h-5.714a1.614,1.614,0,0,1-.985-.261,1.9,1.9,0,0,1-.58-.812l-.523-1.334-1.1-2.784q-.551-1.392-1.073-2.813H604.652q-.754,2.031-1.465,3.814t-1.2,3.117a1.5,1.5,0,0,1-1.509,1.073h-5.8a1.673,1.673,0,0,1-.883-.2.665.665,0,0,1-.334-.609A.858.858,0,0,1,593.487,800.834Zm20.184-30.943q-1.566,4-3.118,8.294t-3.117,8.265H619.79Z",
    transform: "translate(-517.8 -752.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 517.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M640,760.147a1.347,1.347,0,0,1,.334-.928,1.19,1.19,0,0,1,.942-.377h6.67a1.651,1.651,0,0,1,.768.188,1.886,1.886,0,0,1,.653.595q4.959,7.077,9.831,14.051t9.831,14.05V759.944a1.3,1.3,0,0,1,.435-.812,1.272,1.272,0,0,1,.841-.29h5.6a1.522,1.522,0,0,1,1,.348,1.147,1.147,0,0,1,.42.928v40.6q0,1.189-1.363,1.189h-6.293a1.512,1.512,0,0,1-1.189-.783q-5.1-7.4-10.165-14.776t-10.135-14.8v29.087a1.338,1.338,0,0,1-.3.957,1.382,1.382,0,0,1-1.03.319h-5.568a1.256,1.256,0,0,1-.972-.334,1.3,1.3,0,0,1-.3-.913Z",
    transform: "translate(-517.8 -752.84)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 515.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M571.675,854.231a26.582,26.582,0,0,1-.972,7.254,25.891,25.891,0,0,1-2.773,6.408,26.655,26.655,0,0,1-9.845,9.486,27.9,27.9,0,0,1-6.57,2.61,28.909,28.909,0,0,1-7.308.918H526.459a2.278,2.278,0,0,1-1.152-.288,1.29,1.29,0,0,1-.5-1.224V829.1a1.783,1.783,0,0,1,.413-1.224,1.573,1.573,0,0,1,1.243-.468h17.748a28.174,28.174,0,0,1,7.29.936,27.619,27.619,0,0,1,6.552,2.664,28.147,28.147,0,0,1,5.562,4.14,25.635,25.635,0,0,1,4.3,5.4,27.135,27.135,0,0,1,2.771,6.444A26.15,26.15,0,0,1,571.675,854.231Zm-32.94-13.9v27.684h3.023c.553,0,1.092-.018,1.621-.054s1.056-.078,1.584-.126a14.459,14.459,0,0,0,5.04-1.314,13.975,13.975,0,0,0,4.086-2.88,12.965,12.965,0,0,0,2.736-4.194,13.7,13.7,0,0,0,.99-5.256,13.479,13.479,0,0,0-1.134-5.562,13.752,13.752,0,0,0-3.078-4.392,13.9,13.9,0,0,0-4.554-2.88,15.072,15.072,0,0,0-5.562-1.026Z",
    transform: "translate(-515.8 -752.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 515.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M581.07,829.1a1.716,1.716,0,0,1,.413-1.206,1.5,1.5,0,0,1,1.167-.45h35.716a1.591,1.591,0,0,1,1.225.467,1.779,1.779,0,0,1,.431,1.256v8.9a1.882,1.882,0,0,1-.431,1.167,1.5,1.5,0,0,1-1.261.556H595v8.928h18a1.892,1.892,0,0,1,1.134.324,1.24,1.24,0,0,1,.45,1.08V857.9a1.492,1.492,0,0,1-.4.972,1.426,1.426,0,0,1-1.152.468H595v9.216h24.192a1.446,1.446,0,0,1,1.62,1.651v9.046a.893.893,0,0,1-.288.646q-.144,1.005-1.476,1.005h-36.4a1.679,1.679,0,0,1-1.149-.378,1.477,1.477,0,0,1-.431-1.17Z",
    transform: "translate(-515.8 -752.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, 515.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M626.754,829.026a1.461,1.461,0,0,1,.486-1.148,1.753,1.753,0,0,1,1.206-.431h38.735a1.819,1.819,0,0,1,1.153.395,1.613,1.613,0,0,1,.576,1.184v8.938a2.029,2.029,0,0,1-.45,1.239,1.516,1.516,0,0,1-1.279.592h-12.42v39.419a1.715,1.715,0,0,1-.466,1.171,1.561,1.561,0,0,1-1.221.522H642.517a1.692,1.692,0,0,1-1.149-.486,1.562,1.562,0,0,1-.538-1.207V839.795H628.446a1.678,1.678,0,0,1-1.206-.466,1.809,1.809,0,0,1-.486-1.365Z",
    transform: "translate(-515.8 -752.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, 515.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M671.9,854.231a27.359,27.359,0,0,1,3.747-13.914,27.849,27.849,0,0,1,4.3-5.6,26.862,26.862,0,0,1,5.565-4.3,28.234,28.234,0,0,1,6.575-2.772,27.568,27.568,0,0,1,14.643,0,28.17,28.17,0,0,1,6.593,2.772,27.339,27.339,0,0,1,9.889,9.9,28.574,28.574,0,0,1,2.773,6.588,27.6,27.6,0,0,1,0,14.652,27.873,27.873,0,0,1-2.773,6.552,27.1,27.1,0,0,1-4.3,5.544,28.156,28.156,0,0,1-5.584,4.3,27.564,27.564,0,0,1-27.811,0,27.907,27.907,0,0,1-9.87-9.846,26.866,26.866,0,0,1-2.774-6.552A27.284,27.284,0,0,1,671.9,854.231Zm13.933-.036a15.28,15.28,0,0,0,1.006,5.58,13.764,13.764,0,0,0,2.823,4.518,13.145,13.145,0,0,0,4.3,3.024,14.192,14.192,0,0,0,10.947,0,13.1,13.1,0,0,0,4.315-3.024,13.779,13.779,0,0,0,2.822-4.518,15.914,15.914,0,0,0,0-11.142,13.953,13.953,0,0,0-2.822-4.554,13.415,13.415,0,0,0-19.558,0,13.938,13.938,0,0,0-2.823,4.554A15.327,15.327,0,0,0,685.829,854.2Z",
    transform: "translate(-515.8 -752.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 515.8, 752.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M727.517,879.971q.288-.54.594-1.1a13.259,13.259,0,0,1,.7-1.134l16.2-24.192q-4.14-6.228-8.19-12.312t-8.19-12.312a3.54,3.54,0,0,1-.342-.54,1.625,1.625,0,0,1-.161-.54.35.35,0,0,1,.413-.27,1.385,1.385,0,0,0,.7-.162h12.528a2.311,2.311,0,0,1,2.088,1.368l8.82,13.248,8.928-13.248a2.311,2.311,0,0,1,2.088-1.368h11.988q.4,0,.739.018a1.734,1.734,0,0,1,.593.126.35.35,0,0,1,.252.324,1.559,1.559,0,0,1-.4.936l-16.56,24.732,16.884,25.2a6.427,6.427,0,0,1,.559.918,1.325,1.325,0,0,1,.161.7q0,.54-.648.54H764.382a1.875,1.875,0,0,1-1.117-.36,2.437,2.437,0,0,1-.792-.972l-9.792-14.508L743,879.575a2.455,2.455,0,0,1-.792.972,1.876,1.876,0,0,1-1.115.36H728.165a.814.814,0,0,1-.5-.162.531.531,0,0,1-.216-.45A.7.7,0,0,1,727.517,879.971Z",
    transform: "translate(-515.8 -752.84)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlandetox);
export default __webpack_public_path__ + "static/media/plandetox.99f856c9aa65cf4f435da3ffad5baec3.svg";
export { ForwardRef as ReactComponent };